<section class=" for_whom" id="for_whom">
  <div class="container">
    <div class="row ">
      <div class="col-lg-8 col-xl-9 d-flex justify-content-between flex-column">
        <div class="col-xs-12 text-block">
          <h2 [innerHTML]="'HOME.for-whom.title' | translate"></h2>
          <p [innerHTML]="'HOME.for-whom.descriptions.'+ type | translate">
          </p>
        </div>
        <div class="items-block-1" *ngIf="items.length">
          <app-for-whoom-item [data]="item" *ngFor="let item of items.slice(0,2)"></app-for-whoom-item>
        </div>
      </div>
      <div class="col-lg-4 col-xl-3 items-block-2" *ngIf="items.length">
        <app-for-whoom-item [data]="item"  *ngFor="let item of items.slice(2,4)"></app-for-whoom-item>
      </div>
    </div>
    <div class="line"></div>
  </div>
</section>

